import {
  Box, Button, Container, Flex, Heading, Icon, Spinner, Text,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main/MainLayout';
import LoadingSpinner from '@src/components/shared/LoadingSpinner';
import {
  useActivityManagementPlans,
  useMiscActivityManagementPlans,
} from '@src/modules/performance/context/reports-api-hooks';
import { FiDownloadCloud } from 'react-icons/fi';
import { currentDatabaseSelector } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';
import { useState } from 'react';
import usePerformanceReportsApi from '../../api/usePerformanceReportsApi';

export default function ActivityManagementPlans() {
  const { data: ampData, isLoading: ampIsLoading } = useActivityManagementPlans();
  const { data: miscAmpData, isLoading: miscAmpIsLoading } = useMiscActivityManagementPlans();
  const isLoading = ampIsLoading || miscAmpIsLoading;
  const api = usePerformanceReportsApi();

  const allFiles = [...(ampData ?? []), ...(miscAmpData ?? [])];

  const currentDatabase = useRecoilValue(currentDatabaseSelector);

  const rcaId = currentDatabase?.id;
  const rcaName = currentDatabase?.name;

  const getFileName = (file) => {
    if (file.IsUniversal === true) {
      return new RegExp(`^(.*).${file.FileExtension}`).exec(file.FileName)[1]; // Use provided file name if RCA is ALL
    }

    return `${file.Year}/${file.Year + 3 - 2000} AMP Review for ${rcaName}`;
  };

  const [downloadFileName, setDownloadFileName] = useState(null);
  const downloadFile = (file) => {
    setDownloadFileName(getFileName(file));
    api.downloadActivityManagementPlan(rcaId, file.DownloadLink)
      .then((res) => {
        const blob = new Blob(
          [res],
          { type: res.type },
        );
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${getFileName(file)}.${file.FileExtension}`;
        link.click();
        setDownloadFileName(null);
      });
  };

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Heading as="h1" mb={6}>AMP Review</Heading>
        {isLoading && <LoadingSpinner />}
        {!isLoading
          && (
          <Box mt={8} variant="soft-rounded" size="md">
            {allFiles?.sort((a, b) => b.Year - a.Year)
              .map((file) => (
                <Button
                  key={file.FileName}
                  display="flex"
                  w="100%"
                  justifyContent="space-between"
                  size="lg"
                  variant="outline"
                  colorScheme="blue"
                  mb={4}
                  onClick={() => downloadFile(file)}
                  isDisabled={downloadFileName !== null && downloadFileName === getFileName(file)}
                >
                  <Flex as="span" align="center">
                    {downloadFileName === getFileName(file) ? (
                      <Icon as={Spinner} boxSize={5} mr={2} />
                    ) : (
                      <Icon as={FiDownloadCloud} boxSize={5} mr={2} />
                    )}
                    <Text fontSize="lg" fontWeight="normal">
                      {getFileName(file)}
                    </Text>
                  </Flex>
                  <Text fontSize="sm" fontWeight="normal">
                    {file.FileExtension.toUpperCase()}
                  </Text>
                </Button>
              ))}
            {allFiles.length === 0 && <Text>No reports available.</Text>}
          </Box>
          )}
      </Container>
    </MainLayout>
  );
}
